import { ContactShape } from "@eave/shared/types/api";

export const GET_TRUS_OPERATORS_PENDING = "@GetTRUSOperators/GET_TRUS_OPERATORS_PENDING";
export const GET_TRUS_OPERATORS_FAILURE = "@GetTRUSOperators/GET_TRUS_OPERATORS_FAILURE";
export const GET_TRUS_OPERATORS_SUCCESS = "@GetTRUSOperators/GET_TRUS_OPERATORS_SUCCESS";

interface GetTRUSOperatorsPendingAction {
  type: typeof GET_TRUS_OPERATORS_PENDING;
}

interface GetTRUSOperatorsSuccessAction {
  type: typeof GET_TRUS_OPERATORS_SUCCESS;
  operators: TRUSOperators;
}

interface GetTRUSOperatorsFailureAction {
  type: typeof GET_TRUS_OPERATORS_FAILURE;
  error: string;
}

export interface TRUSOperators {
  loan_officers: ContactShape[];
  loan_managers: ContactShape[];
  closer_funders: ContactShape[];
  post_closers: ContactShape[];
  underwriters: ContactShape[];
}

export interface GetTRUSOperatorsState {
  operators: TRUSOperators;
  loading: boolean;
  error: string;
}

export type GetTRUSOperatorsActionTypes =
  | GetTRUSOperatorsPendingAction
  | GetTRUSOperatorsFailureAction
  | GetTRUSOperatorsSuccessAction;
